import { mount2faAuthentication } from '~/authentication/mount_2fa';

document.addEventListener('DOMContentLoaded', mount2faAuthentication);
